// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const MatchReplaceOriginSchema = z.enum(['PROXY','CODER','VOYAGER'] as const);

export type MatchReplaceOriginType = `${z.infer<typeof MatchReplaceOriginSchema>}`

export default MatchReplaceOriginSchema;
